var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3342 3.67643C31.153 3.03007 30.8 2.44489 30.3128 1.98309C29.8119 1.5071 29.1979 1.16661 28.5288 0.99376C26.0248 0.33376 15.9928 0.33376 15.9928 0.33376C11.8106 0.286177 7.6294 0.49546 3.47282 0.960427C2.80374 1.14604 2.19091 1.49414 1.68882 1.97376C1.19549 2.44843 0.838156 3.03376 0.65149 3.67509C0.20308 6.09075 -0.0147877 8.54355 0.000822911 11.0004C-0.0151771 13.4551 0.202156 15.9071 0.65149 18.3258C0.834156 18.9644 1.19016 19.5471 1.68482 20.0178C2.17949 20.4884 2.79549 20.8284 3.47282 21.0084C6.01016 21.6671 15.9928 21.6671 15.9928 21.6671C20.1804 21.7147 24.3669 21.5055 28.5288 21.0404C29.1979 20.8676 29.8119 20.5271 30.3128 20.0511C30.7998 19.5894 31.1524 19.0041 31.3328 18.3578C31.7929 15.943 32.0167 13.4892 32.0008 11.0311C32.0354 8.56257 31.812 6.09718 31.3342 3.67509V3.67643ZM12.8035 15.5658V6.43643L21.1502 11.0018L12.8035 15.5658Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3b7eac672f048de4d4674b00c714666f.svg";
export { ForwardRef as ReactComponent };